<template>
  <section class="bg-indonesia">
    <div
        class="grid items-center max-w-screen-xl gap-8 px-4 py-8 mx-auto lg:grid-cols-2 xl:gap-16 sm:py-16 lg:px-6">



      <div class="text-black sm:text-lg md-max:order-2">
        <h2 class="mb-4 font-extrabold h2 ">It’s Time To Embark…
        </h2>
        <p class="mb-8 textp">Now is the time to embark on your own coffee adventure and immerse yourself in the captivating world of Rony Lavan's Peruvian microlots.
        </p>
        <p class="mb-8 textp">Savor the delicate interplay of flavors, the invigorating aroma, and the knowledge that every sip supports a brighter future for the dedicated farmers of Cajamarca.

        </p>



      </div>

      <nuxt-img class="mb-4 w-full lg:mb-0 rounded-lg m-auto object-cover max-h-[500px]"
                width="484"
                height="776"
                loading="lazy"
                format="webp"
                sizes="sm:440px md:600px lg:720px xl:484px"
                src="/assets/images/indonesia-6.jpg" alt="cajamarca embark"/>
    </div>
  </section>
</template>

<script setup>

defineBuilderComponent({
    friendlyName: 'Content_Section_4',
    ignored: true
})

</script>